import router from '@/router'
import Main from '@/pages/main'

const asyncRoutes = [
  {
    path: '/home',
    name: 'Home',
    component: resolve => require(['@/pages/main/home'], resolve),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/user/list',
    name: 'UserList',
    component: resolve => require(['@/pages/main/user/user'], resolve),
    meta: {
      title: 'talk用户'
    }
  },
  {
    path: '/ydUser/list',
    name: 'ydUserList',
    component: resolve => require(['@/pages/main/ydUser/user'], resolve),
    meta: {
      title: '银达用户'
    }
  },{
    path: '/user/userList',
    name: 'UserList',
    component: resolve => require(['@/pages/main/user/userList'], resolve),
    meta: {
      title: '省农行用户'
    }
  },
  {
    path: '/user/canteenSms',
    name: 'CanteenSms',
    component: resolve => require(['@/pages/main/user/canteenSms'], resolve),
    meta: {
      title: '省农行食堂短信群发'
    }
  },
  {
    path: '/user/equipment',
    name: 'Equipment',
    component: resolve => require(['@/pages/main/user/equipment'], resolve),
    meta: {
      title: '设备人脸识别日志'
    }
  },
  {
    path: '/user/transactionFlow',
    name: 'TransactionFlow',
    component: resolve => require(['@/pages/main/user/transactionFlow'], resolve),
    meta: {
      title: '交易流水'
    }
  },  {
    path: '/user/userBalance',
    name: 'UserBalance',
    component: resolve => require(['@/pages/main/user/userBalance'], resolve),
    meta: {
      title: '用户余额'
    }
  },
  {
    path: '/user/faceBrushingAndTrading',
    name: 'faceBrushingAndTrading',
    component: resolve => require(['@/pages/main/user/faceBrushingAndTrading'], resolve),
    meta: {
      title: '刷脸记录与交易流水'
    }
  },
  //市农行 -> 商户管理
  {
    path: '/snh/merchantManagement',
    name: 'merchantManagement',
    component: resolve => require(['@/pages/main/snh/merchantManagement'], resolve),
    meta: {
      title: '商户管理'
    }
  },
  {
    path: '/snh/order',
    name: 'snhOrder',
    component: resolve => require(['@/pages/main/snh/order'], resolve),
    meta: {
      title: '订单'
    }
  },
  {
    path: '/snh/fullReductionActivities',
    name: 'fullReductionActivities',
    component: resolve => require(['@/pages/main/snh/fullReductionActivities'], resolve),
    meta: {
      title: '活动'
    }
  },
  {
    path: '/snh/transactionDetails',
    name: 'transactionDetails',
    component: resolve => require(['@/pages/main/snh/transactionDetails'], resolve),
    meta: {
      title: '交易明细'
    }
  },
  {
    path: '/snh/transactionInwardTurnWithStnt',
    name: 'transactionInwardTurnWithStnt',
    component: resolve => require(['@/pages/main/snh/transactionInwardTurnWithStnt'], resolve),
    meta: {
      title: '内转出金对账单'
    }
  },
  {
    path: '/snh/transactionPlatformMerchantStatement',
    name: 'transactionPlatformMerchantStatement',
    component: resolve => require(['@/pages/main/snh/transactionPlatformMerchantStatement'], resolve),
    meta: {
      title: '平台商户对账单'
    }
  },
  {
    path: '/snh/transactionWxAli',
    name: 'transactionWxAli',
    component: resolve => require(['@/pages/main/snh/transactionWxAli'], resolve),
    meta: {
      title: '微信支付宝对账单'
    }
  },
  {
    path: '/snh/outOfGoldDetails',
    name: 'outOfGoldDetails',
    component: resolve => require(['@/pages/main/snh/outOfGoldDetails'], resolve),
    meta: {
      title: '出金记录'
    }
  },
  {
    path: '/snh/inOfGoldDetails',
    name: 'inOfGoldDetails',
    component: resolve => require(['@/pages/main/snh/inOfGoldDetails'], resolve),
    meta: {
      title: '入金记录'
    }
  },
  {
    path: '/snh/transactionStatement',
    name: 'transactionStatement',
    component: resolve => require(['@/pages/main/snh/transactionStatement'], resolve),
    meta: {
      title: '交易对账单'
    }
  },
  {
    path: '/snh/marketingSubsidies',
    name: 'marketingSubsidies',
    component: resolve => require(['@/pages/main/snh/marketingSubsidies'], resolve),
    meta: {
      title: '营销补贴'
    }
  },
  {
    path: '/snh/merchantOrderSummary',
    name: 'merchantOrderSummary',
    component: resolve => require(['@/pages/main/snh/merchantOrderSummary'], resolve),
    meta: {
      title: '商户汇总'
    }
  },
  {
    path: '/snh/merchantCloudTrumpet',
    name: 'merchantCloudTrumpet',
    component: resolve => require(['@/pages/main/snh/merchantCloudTrumpet'], resolve),
    meta: {
      title: '云喇叭'
    }
  },{
    path: '/snh/whiteList',
    name: 'whiteList',
    component: resolve => require(['@/pages/main/snh/whiteList'], resolve),
    meta: {
      title: '白名单'
    }
  },
  {
    path: '/word/wordList',
    name: 'WordList',
    component: resolve => require(['@/pages/main/word/wordList'], resolve),
    meta: {
      title: '单词列表'
    }
  },
  {
    path: '/word/wordPackage',
    name: 'WordPackage',
    component: resolve => require(['@/pages/main/word/wordPackage'], resolve),
    meta: {
      title: '单词包'
    }
  },
  {
    path: '/hk/FaceRecognitionRecord',
    name: 'FaceRecognitionRecord',
    component: resolve => require(['@/pages/main/hk/FaceRecognitionRecord'], resolve),
    meta: {
      title: '人脸识别记录'
    }
  },
  {
    path: '/arcsoft/faceDatabase',
    name: 'faceDatabase',
    component: resolve => require(['@/pages/main/arcsoft/faceDatabase'], resolve),
    meta: {
      title: '人脸库'
    }
  },
  {
    path: '/arcsoft/groupListQuery',
    name: 'groupListQuery',
    component: resolve => require(['@/pages/main/arcsoft/groupListQuery'], resolve),
    meta: {
      title: '组列表查询'
    }
  },
  {
    path: '/kry/order',
    name: 'OrderList',
    component: resolve => require(['@/pages/main/kry/order'], resolve),
    meta: {
      title: '订单列表'
    }
  },{
    path: '/QRCode/list',
    name: 'QRCode',
    component: resolve => require(['@/pages/main/QRCode/list'], resolve),
    meta: {
      title: '二维码列表'
    }
  },
  {
    path: '/information/edit',
    name: 'InformationEdit',
    component: resolve => require(['@/pages/main/information/informationEdit'], resolve),
    meta: {
      title: '资讯发布'
    }
  },
  {
    path: '/information/platform',
    name: 'InformationPlatform',
    component: resolve => require(['@/pages/main/information/informationPlatform'], resolve),
    meta: {
      title: '我的资讯'
    }
  },
  {
    path: '/information/auth',
    name: 'InformationAuth',
    component: resolve => require(['@/pages/main/information/informationAuth'], resolve),
    meta: {
      title: '资讯审核'
    }
  },
  {
    path: '/information/settings',
    name: 'InformationSettings',
    component: resolve => require(['@/pages/main/information/informationSettings'], resolve),
    meta: {
      title: '资讯设置'
    }
  },
  {
    path: '/video/platform',
    name: 'VideoPlatform',
    component: resolve => require(['@/pages/main/video/videoPlatform'], resolve),
    meta: {
      title: '我的视频'
    }
  },
  {
    path: '/video/edit',
    name: 'VideoEdit',
    component: resolve => require(['@/pages/main/video/videoEdit'], resolve),
    meta: {
      title: '视频发布'
    }
  },
  {
    path: '/video/auth',
    name: 'VideoAuth',
    component: resolve => require(['@/pages/main/video/videoAuth'], resolve),
    meta: {
      title: '视频审核'
    }
  },
  {
    path: '/sensitive/word',
    name: 'SensitiveWord',
    component: resolve => require(['@/pages/main/sensitive/sensitiveWord'], resolve),
    meta: {
      title: '敏感词'
    }
  },
  {
    path: '/activity/list',
    name: 'ActivityList',
    component: resolve => require(['@/pages/main/activity/activityList'], resolve),
    meta: {
      title: '活动列表'
    }
  },
  {
    path: '/lost/auth',
    name: 'LostAuth',
    component: resolve => require(['@/pages/main/lost/lostAuth'], resolve),
    meta: {
      title: '寻人审核'
    }
  },
  {
    path: '/lost/classify',
    name: 'LostClassify',
    component: resolve => require(['@/pages/main/lost/lostClassify'], resolve),
    meta: {
      title: '寻人分类'
    }
  },
  {
    path: '/ad/edit',
    name: 'AdEdit',
    component: resolve => require(['@/pages/main/ad/adEdit'], resolve),
    meta: {
      title: '发布广告'
    }
  },
  {
    path: '/ad/platform',
    name: 'AdPlatform',
    component: resolve => require(['@/pages/main/ad/adPlatform'], resolve),
    meta: {
      title: '我的广告'
    }
  },
  {
    path: '/ad/auth',
    name: 'AdAuth',
    component: resolve => require(['@/pages/main/ad/adAuth'], resolve),
    meta: {
      title: '广告审核'
    }
  },
  {
    path: '/ad/settings',
    name: 'AdSettings',
    component: resolve => require(['@/pages/main/ad/adSettings'], resolve),
    meta: {
      title: '广告设置'
    }
  },
  {
    path: '/wallet/list',
    name: 'WalletList',
    component: resolve => require(['@/pages/main/wallet/walletList'], resolve),
    meta: {
      title: '钱包列表'
    }
  },
  {
    path: '/wallet/auth',
    name: 'WalletAuth',
    component: resolve => require(['@/pages/main/wallet/walletAuth'], resolve),
    meta: {
      title: '提现审核'
    }
  },
  {
    path: '/gift/list',
    name: 'GiftList',
    component: resolve => require(['@/pages/main/gift/giftList'], resolve),
    meta: {
      title: '礼物列表'
    }
  },
  {
    path: '/report/list',
    name: 'ReportList',
    component: resolve => require(['@/pages/main/report/reportList'], resolve),
    meta: {
      title: '举报列表'
    }
  },
  {
    path: '/deduction/list',
    name: 'DeductionList',
    component: resolve => require(['@/pages/main/deduction/deductionList'], resolve),
    meta: {
      title: '实物抵扣列表'
    }
  },
  {
    path: '/gallery',
    name: 'Gallery',
    component: resolve => require(['@/pages/main/gallery'], resolve),
    meta: {
      title: '图库管理'
    }
  },
  {
    path: '/role/user',
    name: 'RoleUser',
    component: resolve => require(['@/pages/main/role/roleUser'], resolve),
    meta: {
      title: '用户管理'
    }
  },
  {
    path: '/role/auth',
    name: 'RoleAuth',
    component: resolve => require(['@/pages/main/role/roleAuth'], resolve),
    meta: {
      title: '角色管理'
    }
  },
  {
    path: '/menu/list',
    name: 'RoleAuth',
    component: resolve => require(['@/pages/main/menu/list'], resolve),
    meta: {
      title: '菜单列表'
    }
  },
  {
    path: '/menu/menuTree',
    name: 'RoleAuth',
    component: resolve => require(['@/pages/main/menu/menuTree'], resolve),
    meta: {
      title: '菜单树'
    }
  },
  {
    path: '/agent/list',
    name: 'AgentList',
    component: resolve => require(['@/pages/main/agent/agentList'], resolve),
    meta: {
      title: '代理商列表'
    }
  },
  {
    path: '/small/auth',
    name: 'SmallAuth',
    component: resolve => require(['@/pages/main/small/smallAuth'], resolve),
    meta: {
      title: '小视频管理'
    }
  },
  {
    path: '/map/red',
    name: 'MapRed',
    component: resolve => require(['@/pages/main/map/mapRed'], resolve),
    meta: {
      title: '红包地图'
    }
  },
  {
    path: '/map/mine',
    name: 'MapMine',
    component: resolve => require(['@/pages/main/map/mapMine'], resolve),
    meta: {
      title: '我的红包'
    }
  },
  {
    path: '/settings/privacy',
    name: 'SettingsPrivacy',
    component: resolve => require(['@/pages/main/settings/settingsPrivacy'], resolve),
    meta: {
      title: '隐私协议'
    }
  },
  {
    path: '/settings/user',
    name: 'SettingsUser',
    component: resolve => require(['@/pages/main/settings/settingsUser'], resolve),
    meta: {
      title: '用户管理协议'
    }
  },
  {
    path: '/settings/about',
    name: 'SettingsAbout',
    component: resolve => require(['@/pages/main/settings/settingsAbout'], resolve),
    meta: {
      title: '关于我们'
    }
  },
  {
    path: '/settings/disclaimer',
    name: 'SettingsDisclaimer',
    component: resolve => require(['@/pages/main/settings/settingsDisclaimer'], resolve),
    meta: {
      title: '免责申明'
    }
  },
]

/**
 * 过滤路由
 * */
function filterAsyncRoutes (allRouter = [], userRouter = []) {
  const realRoutes = [
    {
      path: '/main',
      name: 'Main',
      component: Main,
      children: []
    }
  ]
  allRouter.forEach(v => {
    userRouter.forEach(item => {
      if (v.meta.title === item.name) {
        realRoutes[0].children.push(v)
      } else if (item.children && item.children.length) {
        item.children.forEach(item2 => {
          if (v.meta.title == item2.name) {
            realRoutes[0].children.push(v)
          }
        })
      }
    })
  })
  return realRoutes
}

export const generateRoutes = function (roles) {
  router.addRoutes(filterAsyncRoutes(asyncRoutes, roles))
  return Promise.resolve()
}
